import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getCommuneAllPage,
  getCommuneByCodeWilayaAllPage,
  deleteCommune,
} from "./ServiceCommune";

import { useTranslation } from "react-i18next";
import { getAllWilaya } from "../wilaya/ServiceWilaya";

import ConfirmationModal from "../../components/home/ConfirmationModal";
import "moment/locale/fr";
import moment from "moment";

export default function ListCommune() {
 const { t } = useTranslation();
  /***************************Liste Wilaya**************************** */
  const [wilayas, setWilayas] = useState([]);
  const [selectedWilaya, setSelectedWilaya] = useState("");

  const loadWilayas = async () => {
    try {
      const result = await getAllWilaya();
      const data = Array.isArray(result.data)
        ? result.data
        : result.data.content || [];
      const sortedData = [...data].sort(
        (a, b) => Number(a.codeWilaya) - Number(b.codeWilaya)
      );

      setWilayas(sortedData);
    } catch (error) {
      //console.log(error);
    }
  };

  /**************************Pagination*********************************/
  const [totalpage, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = totalpage;
  const range = 1;
  const startRange = Math.max(currentPage - range, 0);
  const endRange = Math.min(currentPage + range, totalPages - 1);
  const firstPage = () => {
    setCurrentPage(0);
  };
  const lastPage = () => {
    setCurrentPage(totalPages - 1);
  };

  const prePage = () => {
    if (currentPage !== 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage !== totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  //Nombre D'enregistrement par table
  const [nombrEnreg, setNombreEnrg] = useState(5);

  /*********Searche Data**************************************************/
  const [search, setSearch] = useState("");

  /*******************Ordonné la table par ASC ,DESC**********************/
  const [order, setOrder] = useState("ASC");
  const SortTableAsc = () => {
    if (order === "DESC") {
      setOrder("ASC");
    }
  };

  const SortTableDesc = () => {
    if (order === "ASC") {
      setOrder("DESC");
    }
  };

  /*************Trier par champs des tables*****************************/
  const [selectedValues, setSelectedValues] = useState([]);
  //convertir le tableau en caine de caractere
  const [seletedValuesChaine, setseletedValuesChaine] = useState("");

  const handleCheckBoxChange = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;
    if (checked) {
      // La valeur n'est pas sélectionnée, l'ajouter au tableau
      setSelectedValues([...selectedValues, value]);
    } else {
      // La valeur existe dans le tableau la supprimer
      setSelectedValues(selectedValues.filter((val) => val !== value));
    }
  };

  /*************Charger les données************************************/
  const [communeData, SetcommuneData] = useState([]);

  const loadcommune = async () => {
    try {
      let result;

      // aucune wilaya sélectionnée
      if (
        selectedWilaya === "" ||
        selectedWilaya === null ||
        selectedWilaya === undefined
      ) {
        result = await getCommuneAllPage(
          search,
          currentPage,
          nombrEnreg,
          seletedValuesChaine,
          order
        );
      } else {
        result = await getCommuneByCodeWilayaAllPage(
          selectedWilaya,
          search,
          currentPage,
          nombrEnreg,
          seletedValuesChaine,
          order
        );
      }

      SetcommuneData(result?.data?.content ?? []);
      setTotalPages(result.data.totalPages);
    } catch (error) {
      //console.log(error);
    }
  };


  //Gerer les erreurs renvoyer du serveurs
  //const [errorMessage, setErrorMessage] = useState([]);

  /*********************Delete Data*************************************/
  const [communeId, setcommuneId] = useState();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const selectId = (id) => {
    setcommuneId(id);
    setShowConfirmationModal(true); //afficher le modal
  };

  const handleCloseModal = () => {
    setShowConfirmationModal(false); //fermer le modal
  };

  const deletecommune = async () => {
    try {
      await deleteCommune(communeId);
      loadcommune();
      setShowConfirmationModal(false); //fermer le modal
      toast.success( t("commune.deleteSuccess"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Temps d'affichage du toast (en millisecondes)
        //hideProgressBar: true, // Masquer la barre de progression
        closeOnClick: true, // {t("button.close")} le toast lorsqu'il est cliqué
        pauseOnHover: true, // Mettre en pause la durée de vie du toast lorsqu'il est survolé
        draggable: true, // Permettre de faire glisser le toast
        //progress: undefined, // Composant personnalisé pour la barre de progression
        // ...autres options
      });
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        // Récuperer les erreurs de validation ou le message d'erreur renvoyé par le serveur
        const errorArray = error.response.data.errors;

        //afficher les erreurs dans le toast
        const formattedErrors = errorArray.map((error, index) => {
          return (
            <li className="list-group-item" key={index}>
              {error}
            </li>
          );
        });

        toast.error(
          <div style={{ width: "15rem" }}>
            <div className="card-header text-danger">
              <h5 className="card-title">Erreurs de suppression !</h5>
            </div>
            <div className="card-body">
              <p className="card-text"></p>
              <ul className="list-group list-group-flush">{formattedErrors}</ul>
            </div>
          </div>,
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000, // Temps d'affichage du toast (en millisecondes)
            //hideProgressBar: true, // Masquer la barre de progression
            closeOnClick: true, // {t("button.close")} le toast lorsqu'il est cliqué
            pauseOnHover: true, // Mettre en pause la durée de vie du toast lorsqu'il est survolé
            draggable: true, // Permettre de faire glisser le toast
            //progress: undefined, // Composant personnalisé pour la barre de progression
            // ...autres options
          }
        );
        setShowConfirmationModal(false); //fermer le modal
      } else {
        console.log(
          "Une erreur s'est produite lors de la suppression des données."
        );
      }
    }
  };

  /*********************************************************************/

  useEffect(() => {
    loadWilayas();
  }, []);



  useEffect(() => {
    if (currentPage >= totalPages && totalPages > 0) {
      setCurrentPage(0);
    }

    setseletedValuesChaine(selectedValues.join(","));
    loadcommune();
  }, [
    search,
    currentPage,
    nombrEnreg,
    seletedValuesChaine,
    order,
    selectedValues,
    selectedWilaya,
  ]);

  return (
    <div className="container-fluid px-4" style={{ marginTop: "5rem" }}>

      {/* Breadcrumb */}
      <nav className="mb-3">
        <ol className="breadcrumb bg-white px-3 py-2 shadow-sm rounded-3">
          <li className="breadcrumb-item">
            <Link to="/" className="text-decoration-none">
              <i className="fa-solid fa-house me-1"></i>  {t("menu.home")}
            </Link>
          </li>
          <li className="breadcrumb-item active"> {t("commune.titre")} </li>
        </ol>
      </nav>

      {/* Header */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body d-flex justify-content-between align-items-center">
          <h4 className="mb-0 fw-bold text-primary">
            <i className="fa-solid fa-list me-2"></i>
             {t("commune.list")}
          </h4>

          <Link
            to="/Addcommune"
            className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "45px", height: "45px" }}
            title="Ajouter"
          >
            <i className="fa-solid fa-plus"></i>
          </Link>
        </div>
      </div>


<div className="card shadow-sm border-0 mb-3">
  <div className="card-body py-2">

    <div className="row g-2 align-items-center">

      {/* Recherche */}
      <div className="col-md-4">
        <div className="input-group input-group-sm">
          <span className="input-group-text">
            <i className="fa-solid fa-magnifying-glass"></i>
          </span>

          <input
            type="search"
            className="form-control"
            placeholder="Recherche..."
            onChange={(e) => {
              firstPage();
              setSearch(e.target.value);
            }}
          />
        </div>
      </div>

      {/* Wilaya */}
      <div className="col-md-3">
        <select
          className="form-select form-select-sm"
          value={selectedWilaya}
          onChange={(e) => {
            firstPage();
            setSelectedWilaya(e.target.value);
          }}
        >
          <option value="">
            {t("consultant.filters.all")}
          </option>

          {wilayas.map((w) => (
            <option
              key={w.id}
              value={w.codeWilaya}
            >
              {w.codeWilaya} - {w.wilaya}
            </option>
          ))}
        </select>
      </div>

      {/* Nombre de {t("common.rows")} */}
      <div className="col-md-2">
        <select
          className="form-select form-select-sm"
          value={nombrEnreg}
          onChange={(e) => setNombreEnrg(e.target.value)}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div>

      {/* Tri */}
      <div className="col-md-3 text-end">
        <div className="btn-group btn-group-sm">

          <button
            className={`btn btn-outline-primary ${
              selectedValues.length === 0 ? "disabled" : ""
            }`}
            onClick={SortTableAsc}
          >
            <i className="fa-solid fa-arrow-down-a-z"></i>
          </button>

          <button
            className={`btn btn-outline-primary ${
              selectedValues.length === 0 ? "disabled" : ""
            }`}
            onClick={SortTableDesc}
          >
            <i className="fa-solid fa-arrow-up-z-a"></i>
          </button>

        </div>
      </div>

    </div>
  </div>
</div>


      {/* Table */}
      <div className="card shadow-sm border-0">

        <div className="table-responsive">
          <table className="table table-striped table-hover">

            <thead className="table-dark">
              <tr>

                <th>
                  <input type="checkbox" value="codeCommune" onChange={handleCheckBoxChange} />  {t("common.code")}
                </th>

                <th>
                  <input type="checkbox" value="commune" onChange={handleCheckBoxChange} /> {t("common.french")}
                </th>
                <th>
                  <input type="checkbox" value="communeArab" onChange={handleCheckBoxChange} />  {t("common.arabic")}
                </th>
                <th>
                  <input type="checkbox" value="communeAng" onChange={handleCheckBoxChange} />  {t("common.english")}
                </th>
                <th className="text-center">{t("common.actions")}</th>
              </tr>
            </thead>

            <tbody>
              {communeData.map((item) => (
                <tr key={item.id}>
                  <td>{item.codeCommune}</td>
                  <td>{item.commune}</td>
                  <td>{item.communeArab}</td>
                  <td>{item.communeAng}</td>

                  <td className="text-center">
                    <Link
                      to={`/Updatecommune/${item.id}`}
                      className="btn btn-sm btn-outline-success me-2 rounded-circle"
                    >
                      <i className="fa-solid fa-pen"></i>
                    </Link>

                    <button
                      className="btn btn-sm btn-outline-danger rounded-circle"
                      onClick={() => selectId(item.id)}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>

        {/* Pagination */}
        <div className="card-footer bg-white border-0">
          <nav>
            <ul className="pagination justify-content-center mb-0">

              <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
                <button className="page-link" onClick={firstPage}>
                  «
                </button>
              </li>

              <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
                <button className="page-link" onClick={prePage}>
                  ‹
                </button>
              </li>

              {Array.from({ length: totalPages }).map((_, index) => (
                <li
                  key={index}
                  className={`page-item ${currentPage === index ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(index)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}

              <li className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={nextPage}>
                  ›
                </button>
              </li>

              <li className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={lastPage}>
                  »
                </button>
              </li>

            </ul>
          </nav>
        </div>

      </div>

      {/* Modal */}
      <ConfirmationModal
        isOpen={showConfirmationModal}
        onConfirm={deletecommune}
        onCancel={handleCloseModal}
      />

    </div>
  );
}
